import { render, staticRenderFns } from "./KakaoLoginPage.vue?vue&type=template&id=314855da"
import script from "./KakaoLoginPage.vue?vue&type=script&lang=js"
export * from "./KakaoLoginPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports